/**
 * GENERATED CODE – DO NOT EDIT!
 */
/* eslint-disable */
import * as $protobuf from 'protobufjs/light';
import { fixType } from '../../Fixes';
import Builder from '../../Builder';
const $root = $protobuf.roots['default'] || ($protobuf.roots['default'] = new $protobuf.Root());
const jsonData = {
  "squareup": {
    "nested": {
      "client": {
        "nested": {
          "MobileStaff": {
            "fields": {
              "userToken": {
                "type": "string",
                "id": 1,
                "rule": "optional"
              },
              "photoUrl": {
                "type": "string",
                "id": 2,
                "rule": "optional"
              },
              "fullName": {
                "type": "string",
                "id": 3,
                "rule": "optional"
              }
            }
          }
        }
      }
    }
  }
};

// Do not initialize these protos if they have already been defined
if (!$root.nested?.squareup?.nested?.client?.nested?.MobileStaff) {
  $root.addJSON(jsonData);
}

/**
 * Information about a mobile staff member
 * A Mobile staff employee has their own login into the system.
 *
 * SOURCE MobileStaff @ squareup/client/mobile_staff.proto at 19:1
 */
export const MobileStaff = $root.lookupType('squareup.client.MobileStaff');
fixType(MobileStaff, {
  userToken: {
    required: true
  }
});
Builder.createAndAttachToType(MobileStaff);